module.exports = __webpack_public_path__ + "media/ygx_logo.0ecbe1c4.mp4";